export default __webpack_public_path__ + "static/media/religious.bd4a5f88.jpg";